/* eslint-disable filename-export/match-default-export */
import React, { createContext, useContext, useEffect, useState } from 'react';
import propTypes from 'prop-types';
import stringifyEditorYaml from 'app/components/YamlCodeEditor/stringifyEditorYaml';

const PlaybookFiltersContext = createContext();

export default function PlaybookFiltersContextProvider({ children, filtersValue, filtersPath }) {
  const yamlFilters = stringifyEditorYaml(filtersValue);
  const [value, setValue] = useState(yamlFilters);

  useEffect(() => {
    setValue(yamlFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [yamlFilters]);

  return (
    <PlaybookFiltersContext.Provider
      value={{
        value,
        setValue,
        filters: filtersValue,
        filtersPath,
      }}
    >
      {children}
    </PlaybookFiltersContext.Provider>
  );
}

export function usePlaybookFiltersContext() {
  return useContext(PlaybookFiltersContext);
}

PlaybookFiltersContextProvider.propTypes = {
  children: propTypes.node.isRequired,
  filtersValue: propTypes.object,
  filtersPath: propTypes.string,
};
